module.exports = vendors_ru_df7294bc8d2d33e10496;